/* main.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./main.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, useMemo, useState } from 'react';
import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { SearchTriggerInputContext } from './search-trigger-context';
var EXPANDED_WIDTH = '320px';
var rootStyles = null;
var hoverFocusStyles = null;
var expandedStyles = null;
var boxStyles = null;
var subtlePlaceholderStyles = null;
var layoutStyles = null;
var inputContainerStyles = null;
var labelOverlayStyles = null;
var buttonContainerStyles = null;
export var SearchTrigger = function SearchTrigger(_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    submitButton = _ref.submitButton,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var isAtRest = value.length === 0 && !isFocused;
  var isExpanded = !isAtRest || isHovered;
  var VisuallyHiddenPlaceholder = isFocused || value.length > 0 ? VisuallyHidden : Fragment;
  var contextValue = useMemo(function () {
    return {
      isExpanded: isExpanded,
      isHovered: isHovered,
      isFocused: isFocused,
      setIsHovered: setIsHovered,
      setIsFocused: setIsFocused,
      value: value,
      onChange: onChange,
      isAtRest: isAtRest,
      interactive: interactive
    };
  }, [isExpanded, isHovered, isFocused, value, onChange, isAtRest, interactive]);
  var mouseEnterLeaverProps = interactive ? {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  } : {};
  return /*#__PURE__*/React.createElement(SearchTriggerInputContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_v564130x _1bsbp3fh _m6k41jlu", interactive && "_195pnklw _1chpnklw", interactive && isExpanded && "_1bsbnklw"])
  }, /*#__PURE__*/React.createElement("div", _extends({}, mouseEnterLeaverProps, {
    className: ax(["_2rko1rr0 _zulp12x7 _v5641yk7 _11c81ixg _1h6dysee _1dqonqa1 _1bsb1osq _vchhusvi _1e0c1txw _4cvr1fhb _bfhkvuon _16qszucj _tzy4kb7n _3um0ewfl _w6ng15vq _t9ecmk3q _y4tiu2gc _syazi7uo _4t3i8vuz"])
  }), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _1bsb1osq"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswh2mm _1bsb1osq"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp12x7 _1wpz1h6o _1e0c1txw _kqswstnw _1ltvpxbi _154iidpf _94n5idpf _lcxvglyw _80om1kdv", isAtRest && "_syaz1rpy"])
  }, /*#__PURE__*/React.createElement(AiChatIcon, {
    spacing: "spacious",
    label: ""
  }), /*#__PURE__*/React.createElement(VisuallyHiddenPlaceholder, null, placeholder)), children), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1wpz1h6o"])
  }, submitButton)))));
};